import React from 'react';
import Footer from '../../components/Common/Footer/Footer';
import Header from '../../components/Common/Header/Header';
import MostView from '../../components/Common/MostView/MostView';
import SubHeader from '../../components/Common/SubHeader/SubHeader';
import Subscription from '../../components/Common/Subscription/Subscription';
import ProductDetailsBanner from '../../components/ProductDetails/ProductDetailsBanner/ProductDetailsBanner';

const ProductDetails = () => {
    return (
        <div>
            <SubHeader/>
            <Header/>
            <ProductDetailsBanner/>
            <MostView/>
            <Subscription/>
            <Footer/>
        </div>
    );
};

export default ProductDetails;